import _extends from '@babel/runtime/helpers/extends';
import { forwardRef, Icon } from '@chakra-ui/react';
import * as React from 'react';
var Svg = forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20 7.74-5.46 4.73 1.64 7.03L10 15.77 3.82 19.5l1.63-7.03L0 7.74l7.19-.61L10 .5l2.81 6.63 7.19.61Z",
    fill: "currentColor"
  }));
});
var Star = forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    as: Svg
  }, props, {
    ref: ref
  }));
});
export { Star };